import styled, { keyframes } from "styled-components/macro";
import { Grid } from "../../GlobalStyles.styles";

export const LockBox = styled.div`
  display: ${({ lock }) => (lock ? "block" : "none")};
  position: absolute;
  height: 71%;
  width: 100%;
  background: red;
  z-index: 10000;
`;

export const sweepAnimation = keyframes`
  0% {
    width: 100%;
    left: 0;
  }
  100% {
    width: 0%;
    left: 100%;
  }
`;

export const Sweep = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  background: black;
  animation: ${sweepAnimation} 3.5s linear forwards;
  z-index: 1000000;
`;

export const GridChangeNumericTest = styled(Grid)`
  grid-template-areas:
    "box1 box2"
    "box3 box4"
    "box5 box6";

  grid-template-rows: repeat(auto-fit, 1fr);
  grid-template-columns: 1fr 1fr;
`;

export const GridMain1 = styled(Grid)`

  grid-template-areas:
    "box1 box2"
    "wave1 wave1"
    "wave2 wave2";

  grid-template-rows: repeat(auto-fit, 1fr);
  grid-template-columns: 1fr 1fr;
`;



export const GridMain2 = styled(Grid)`
  grid-template-areas:
    "box1 box2"
    "wave1 wave1"
    "box3 box4";
  grid-template-rows: repeat(auto-fit, 1fr);
  grid-template-columns: 1fr 1fr;
`;



export const GridMain3 = styled(Grid)`
  grid-template-areas:
    "box1 box2"
    "box3 box4"
    "box5 box6";

  grid-template-rows: repeat(auto-fit, 1fr);
  grid-template-columns: 1fr 1fr;
`;


export const GridMain4Landscape = styled(Grid)`
  position: absolute;
  top: 0%;
  width: 289px;
  background: red;
  

  grid-template-areas:
    "topbar topbar topbar"
    "box box box"
    "patient patient patient"
    "hr spo pvc"
    "waveII waveII waveII"
    "wavev wavev wavev";

  grid-template-columns: 1fr 1fr 1fr;

  grid-template-rows: 7% 19% 8% 60px 60px 60px;

  row-gap: 0.2em;

  & img {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
`;

export const GridMain5 = styled(Grid)`
  position: absolute;
  top: 12%;
  left: -19%;

  width: 367px;
  height: 280px;
  transform: rotate(90deg);

  grid-template-areas:
    "patient patient"
    "lead lead"
    "hr spo"
    "pvc pulse"
    "waveII waveII"
    "wavev wavev";
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 40px 40px 50px 50px 50px 1fr;

  background: black;
  row-gap: 0.7em;

  & img {
    border: 3px solid black;
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
`;

export const GridMain6 = styled(Grid)`
  grid-template-areas:
    "box1 box2"
    "xray xray";
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 2fr;
  row-gap: 0.7em;
`;


export const ImgSkeleton = styled.img`
  grid-area: xray;
  
  max-height: 140px;

`;

